import React from "react";
import { Link } from "react-router-dom";

function HomeScreenContentTop() {


  return (
    <div className="p-3">
      <div className="row" style={{ marginTop: "5rem" }}>
        <div className="col-md-6">
          <div style={{ marginLeft: "10rem" }}>
            <div>
              <h1 className="display-5 fw-bold fst-italic">
                We make pdf editing easy
              </h1>
            </div>
            <div className=" mt-4">
              <label className="fs-5">
                All the tools (Edit, Compress, Merge, Split, Converter,
                Watermark etc) you’ll need in your daily professional life to
                work with any pdf documents in one place. <br />
                <br />
                <span className="text-success">
                  Our tool operates entirely on your device, ensuring full data
                  privacy. Your information remains secure at all times.
                </span>
              </label>
            </div>
            <div className="mt-5">
              <Link
                to="/explore_apps"
                className="btn btn-outline-primary"
                aria-label="Explore all PDF tools"
              >
                Explore All PDF Tools
              </Link>
            </div>
          </div>
        </div>

        <div className="col-md-6 d-none d-md-block">
          <img
            loading="lazy"
            src="./images/pdf_doc_homescreen_graphics_1.png"
            alt="graphics_pdf_1"
            style={{
              width: "300px",
              height: "auto",
              maxWidth: "60%",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "auto",
              marginBottom: "auto",
            }}
          ></img>
        </div>
      </div>
    </div>
  );
}

export default HomeScreenContentTop;
